import React from 'react';
import { useLocation } from 'react-router-dom';
import ReduceCircleLine from '@/assets/images/icons/reduce-circle-line.react.svg?react';
import { BASE_NAME, toSearchStr, getParamFromUrl } from '@/infrastructure/history';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import styles from '@/presentation/components/issue-track-icon/index.module.scss';

interface IProps {
  idName: string;
  id: string;
  date: string;
  issueId?: string | null;
  launchId?: string | null;
  processLaunchId?: string | null;
}
export const IssueTrackIcon = (props: IProps) => {
  const { date, idName, id, issueId, launchId, processLaunchId } = props;
  const { pathname } = useLocation();
  if (!id || pathname === '/track') {
    return null;
  }
  const click = () => {
    const str = toSearchStr({
      [idName]: id,
      launchId,
      processLaunchId,
      date,
      issueId: issueId || getParamFromUrl('feature'),
      cId: getParamFromUrl('cId') || getParamFromUrl('feature'),
    });
    const a = document.createElement('a');
    const url = `${location.origin}${BASE_NAME}/track?${str}`;
    a.href = url;
    a.target = '_blank';
    a.click();
  };
  return <div className={styles.icon} onClick={click}>{hintChildren(<ReduceCircleLine/>, '追踪')}</div>;
};
